import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/redo.tsx
var Redo = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M16.792 18.5H8.91999C6.20416 18.5 4 16.1926 4 13.3495C4 10.5064 6.20416 8.19897 8.91999 8.19897H19.744",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeMiterlimit: "10",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M17.481 10.7741L20 8.13706L17.481 5.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.91999 8.94897C6.65036 8.94897 4.75 10.8879 4.75 13.3495C4.75 15.8111 6.65036 17.75 8.91999 17.75H16.792C17.2062 17.75 17.542 18.0858 17.542 18.5C17.542 18.9142 17.2062 19.25 16.792 19.25H8.91999C5.75795 19.25 3.25 16.574 3.25 13.3495C3.25 10.1249 5.75795 7.44897 8.91999 7.44897H19.744C20.1582 7.44897 20.494 7.78476 20.494 8.19897C20.494 8.61319 20.1582 8.94897 19.744 8.94897H8.91999Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.9629 4.95767C17.2624 4.67156 17.7372 4.68243 18.0233 4.98195L20.5423 7.61901C20.8192 7.90888 20.8192 8.36525 20.5423 8.65512L18.0233 11.2922C17.7372 11.5917 17.2624 11.6026 16.9629 11.3164C16.6634 11.0303 16.6525 10.5556 16.9386 10.2561L18.9628 8.13706L16.9386 6.01806C16.6525 5.71854 16.6634 5.24379 16.9629 4.95767Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { Redo };
